import { print } from 'graphql/language/printer';
import { GraphQLClient } from 'graphql-request';
import { ASTNode } from 'graphql';

export async function makeRequest<T>(query: ASTNode, params?: Record<string, any>): Promise<T> {
  const client = new GraphQLClient(process.env.NEXT_PUBLIC_GRAPHQL_CLIENT);

  return client.request<T>(print(query), params);
}

const MAX_RETRIES = 10;
const RETRY_DELAY = 6000;

export const timeout = (ms: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

export async function makeRequestWithRetry<T>(
  query: ASTNode,
  params: Record<string, any>,
  opts: {
    maxRetries?: number;
    retryDelay?: number;
    errorId: string;
  },
  __retryCount = 0
): Promise<T> {
  const { maxRetries = MAX_RETRIES, retryDelay = RETRY_DELAY, errorId } = opts;

  try {
    const client = new GraphQLClient(process.env.NEXT_PUBLIC_GRAPHQL_CLIENT);

    return await client.request<T>(print(query), params);
  } catch (e) {
    if (__retryCount < maxRetries) {
      console.error(`makeRequestWithRetry() [${errorId}] failed. Retry count: ${__retryCount}.`);

      await timeout(retryDelay);
      return await makeRequestWithRetry(query, params, opts, __retryCount + 1);
    }

    console.error(`makeRequestWithRetry() [${errorId}] failed. No more retries left.`, e);
    throw new Error(`makeRequestWithRetry() failed`);
  }
}
